(() => {
  if (customElements.get('ff-cart-offers')) return;
  const root=window.Shopify?.routes?.root||'/';
  let busy=false, manualBasket='';
  const attempted=new Set(), panels=()=>[...document.querySelectorAll('ff-cart-offers')];
  try {manualBasket=sessionStorage.getItem('ff-cart-offer-choice-v1')||'';} catch {}
  const state=p=>JSON.parse(p.querySelector('[data-ff-offers-state]').textContent);
  const basket=v=>JSON.stringify(v.items.map(i=>[String(i.id||i.variant_id),i.quantity]).sort());
  const codes=cart=>[...new Set([
    ...(cart.discount_codes||[]).filter(d=>d.applicable!==false).map(d=>d.code),
    ...(cart.cart_level_discount_applications||[]).filter(d=>d.type==='discount_code').map(d=>d.title),
    ...(cart.items||[]).flatMap(i=>(i.line_level_discount_allocations||[]).map(a=>a.discount_application).filter(d=>d?.type==='discount_code').map(d=>d.title))
  ].filter(Boolean))];
  const message=(value,error=false)=>panels().forEach(p=>{const n=p.querySelector('[data-ff-offers-status]');n.textContent=value;n.dataset.error=String(error);});
  async function request(path,options={}) {
    const r=await fetch(root+path,{credentials:'same-origin',cache:'no-store',...options,signal:AbortSignal.timeout(15000)});
    if(!r.ok)throw Error('Shopify could not update this offer. Please try again.');
    return r;
  }
  async function freshPanel() {
    const html=await(await request('cart?view=ff-offers')).text();
    const p=new DOMParser().parseFromString(html,'text/html').querySelector('ff-cart-offers');
    if(!p)throw Error('The offer summary could not refresh. Open your cart to review the total.');
    return p;
  }
  async function redraw(cart) {
    await Promise.all([...document.querySelectorAll('cart-items')].map(owner=>typeof owner.update==='function'?owner.update(cart):undefined));
    const drawer=document.querySelector('#Cart-Content-Sidebar');
    if(drawer&&document.body.classList.contains('cart-sidebar-show')) {
      const consent=drawer.querySelector('input[name="conditions"]')?.checked===true;
      const html=await(await request('cart?view=ajax_side_cart')).text();
      const fresh=new DOMParser().parseFromString(html,'text/html').querySelector('#Cart-Content-Sidebar');
      if(!fresh)throw Error('Your offer was saved. Reopen your cart to see the updated total.');
      drawer.innerHTML=fresh.innerHTML;
      if(consent){const input=drawer.querySelector('input[name="conditions"]');if(input){input.checked=true;input.dispatchEvent(new Event('change',{bubbles:true}));}}
    }
    document.querySelectorAll('[data-cart-count]').forEach(n=>n.textContent=cart.item_count);
    const fresh=await freshPanel();panels().forEach(p=>p.innerHTML=fresh.innerHTML);
    document.dispatchEvent(new CustomEvent('ff:offers-updated',{detail:{cart}}));
  }
  async function updateCodes(selection) {
    return (await request('cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:selection.join(',')})})).json();
  }
  async function apply(code,mode='manual') {
    if(busy)return;busy=true;message('Checking your offer…');
    panels().forEach(p=>p.querySelectorAll('button').forEach(b=>b.disabled=true));
    try {
      const current=state(await freshPanel());
      if(current.trialQuantity>0||current.currency!=='INR')throw Error('This offer is for eligible regular products in INR. Trial pricing stays unchanged.');
      const cart=await(await request('cart.js')).json(),key=basket(current);
      if(basket(cart)!==key)throw Error('Your cart changed. Review it and apply the offer again.');
      if(mode!=='auto'){manualBasket=key;try{sessionStorage.setItem('ff-cart-offer-choice-v1',key);}catch{}}
      const prior=codes(cart);
      const selection=mode==='remove'?prior.filter(c=>c.toUpperCase()!==code.toUpperCase()):mode==='auto'?[...new Set([...prior,code])]:[code];
      await redraw(await updateCodes(selection));
      const confirmed=panels().length?state(panels()[0]).discounts:[];
      const applied=confirmed.some(d=>d.code?.toUpperCase()===code.toUpperCase());
      if(mode==='manual'&&!applied&&prior.length){
        const latest=await(await request('cart.js')).json();
        if(basket(latest)!==key)throw Error('Your cart changed. Review your offers before checkout.');
        await redraw(await updateCodes(prior));
        message('This code does not apply. Your previous offer has been restored; review the savings shown above.',true);
        return;
      }
      message(mode==='remove'?'Coupon removed. Your total has been updated.':applied?code+' applied. Your savings are included in the total.':'Shopify has not applied this code to your cart. Check the offer conditions or choose another code.',mode!=='remove'&&!applied);
    }catch(error){message(error.message||'Unable to confirm the offer. Please review your cart.',true);}
    finally{busy=false;panels().forEach(p=>p.querySelectorAll('button').forEach(b=>b.disabled=false));}
  }
  function autoApply(panel){
    try{
      const v=state(panel),key=basket(v);
      if(busy||v.trialQuantity||v.currency!=='INR'||v.regularQuantity<3||manualBasket===key||attempted.has(key)||v.discounts.some(d=>d.code.toUpperCase()==='B3P2'))return;
      attempted.add(key);void apply('B3P2','auto');
    }catch{message('Offers are available at checkout.',true);}
  }
  customElements.define('ff-cart-offers',class extends HTMLElement{connectedCallback(){queueMicrotask(()=>autoApply(this));}});
  // Keep the existing loyalty app interactive, above the compact checkout footer.
  const drawer=document.querySelector('#halo-cart-sidebar');
  function placeLoyaltyWidget(){
    const slot=drawer?.querySelector('[data-ff-cart-rewards]');
    const widget=drawer?.querySelector('#cart-sidebar-form .honeypop-cp');
    if(slot&&widget)slot.append(widget);
  }
  if(drawer){new MutationObserver(placeLoyaltyWidget).observe(drawer,{childList:true,subtree:true});placeLoyaltyWidget();}

  document.addEventListener('click',event=>{
    const target=event.target instanceof Element?event.target:null,panel=target?.closest('ff-cart-offers');
    if(!panel)return;
    const button=target.closest('[data-ff-code-apply]'),offer=target.closest('[data-ff-offer]'),remove=target.closest('[data-ff-offer-remove]');
    if(!button&&!offer&&!remove)return;
    event.preventDefault();event.stopPropagation();
    const code=(remove?.dataset.ffOfferRemove||offer?.dataset.ffOffer||panel.querySelector('[data-ff-code]')?.value||'').trim();
    if(!code||code.length>80||/[\u0000-\u001f,]/.test(code)){message('Enter a valid coupon code.',true);return;}
    void apply(code,remove?'remove':'manual');
  });
  document.addEventListener('keydown',event=>{if(event.key==='Enter'&&event.target.matches?.('[data-ff-code]')){event.preventDefault();event.target.closest('ff-cart-offers').querySelector('[data-ff-code-apply]').click();}});
  document.addEventListener('click',event=>{if(busy&&event.target.closest?.('[name="checkout"],[data-ff-wallet-apply]')){event.preventDefault();event.stopImmediatePropagation();message('Please wait while Shopify confirms your savings.');}},true);
  document.addEventListener('submit',event=>{if(busy&&event.target.matches?.('form[action$="/cart"]')){event.preventDefault();event.stopImmediatePropagation();}},true);
})();
